import { Paper } from '@mui/material';
import * as React from 'react';
import ReactJson from 'react-json-view';

import { UserSystemRoleModelPermissionMap } from '../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { AdminTableDomain } from '../../../../../view/admin/page/table/store/AdminTableDomain';
import { IAdminTableColumn } from '../../../../../view/admin/page/table/store/IAdminTableUI';
import { IMainLayoutDomainStore } from '../../../../../view/layout/main/store/domain/IMainLayoutDomainStore';
import { AdminLogRootService } from '../service/AdminLogRootService';
import { AdminLogModel } from './AdminLogModel';
import { AdminLogsUI } from './AdminLogsUI';
import { ILocalization, ILocalizationToken } from '../../../../../application/language/ILocalization';
import { inject } from '../../../../../common/container/inject';

export class AdminLogsDomain extends AdminTableDomain<AdminLogModel, any> {
  constructor(
    layoutDomain: IMainLayoutDomainStore,
    mvideoService = new AdminLogRootService(),
    public ui: AdminLogsUI = new AdminLogsUI(),
    public i18n = inject<ILocalization>(ILocalizationToken),
  ) {
    super(layoutDomain, mvideoService.log);
    this.ui.searchRequest.setEntity({
      limit: 1000,
    });
    this.ui.isInlineEdit.setValue(false);
    this.ui.isShowDelete.setValue(false);
    this.ui.tableOptions = {
      search: false,
    };
    this.setDetailPanel();
  }

  setPermissions() {
    super.setPermissions();
    const isCanLogger = this.layoutDomain.userHaveAnyAccess([
      UserSystemRoleModelPermissionMap['plugin-settings-logger-is-allow'],
    ]);

    this.ui.isCanCreate.setValue(isCanLogger);
    this.ui.isCanDelete.setValue(isCanLogger);
    this.ui.isCanEdit.setValue(isCanLogger);
  }

  setDetailPanel() {
    this.ui.detailPanel = [
      {
        // tooltip: 'details',
        render: (data: { rowData: AdminLogModel }) => {
          //@ts-ignore
          return (
            <Paper
              style={{ padding: '25px', paddingLeft: '27px' }}
              key={`additional_data_${data.rowData.id}`}
              elevation={2}
            >
              <ReactJson src={data.rowData.eventData} theme={'ocean'} />
            </Paper>
          );
        },
      },
    ];
  }

  updateBySearch() {
    this.ui.entities.setList(
      this.ui.allEntities.list.filter((item) => {
        let createDate = item.createDate;
        if (item.createDate) {
          createDate = new Date(item.createDate as number).getTime();
        }
        let isAllowed = true;
        if (this.ui.startDate.value && (createDate || 0) < this.ui.startDate.value) {
          isAllowed = false;
        }
        if (this.ui.endDate.value && (createDate || 0) > this.ui.endDate.value) {
          isAllowed = false;
        }
        if (this.ui.selectedEvents.value.length > 0 && !this.ui.selectedEvents.value.includes(item.event)) {
          isAllowed = false;
        }

        return isAllowed;
      }),
    );
  }

  async loadData() {
    const columns = await this.getColumns();
    this.ui.columns.setList(columns);
    await super.loadData();
    this.ui.allEntities.setList(this.ui.entities.list);
  }

  private async getColumns(): Promise<IAdminTableColumn[]> {
    return [
      {
        title: this.i18n.translate('phrases.user'),
        field: 'userLogin',
      },
      {
        title: this.i18n.translate('phrases.event'),
        field: 'event',
      },
      {
        title: this.i18n.translate('phrases.idEvents'),
        field: 'publicLogId',
      },
      {
        title: this.i18n.translate('phrases.timeEvents'),
        field: 'createDate',
        type: 'datetime',
      },
      {
        title: this.i18n.translate('phrases.text'),
        field: 'eventAsText',
      },
      {
        title: this.i18n.translate('phrases.dns'),
        field: 'hostDNS',
      },
      {
        title: this.i18n.translate('phrases.ip'),
        field: 'hostIP',
      },
    ];
  }
}
